<template>
<div>
  <b-carousel
    id="carousel-fade"
    style="text-shadow: 0px 0px 2px #000"
    fade
    indicators
    img-width="1024"
    img-height="480"
  >
    <b-carousel-slide v-for="photo in photos" :key="photo.idgaleria"
      caption=""
      :img-src="url+photo.url"
    ></b-carousel-slide>
  </b-carousel>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Carousel',
  props: ['idAlojamiento'],
  data() {
    return {
     photos: [],
     url : process.env.VUE_APP_S3_URL
    }
  }, 
  created(){
    var that = this;
		return new Promise(() => {
			axios({url: process.env.VUE_APP_API_URL+'galleries/searchByAccommodation/'+this.idAlojamiento, method: 'GET' })
			.then(resp => {
        resp.data.photos.map(function(value, key) {
          that.photos.push(value);
        });   
			})
		})
  }  
}
</script>

